import { ReactComponent as ArrowForward } from "../assets/svg/arrow_forward.svg";
import { ReactComponent as NavigateBefore } from "../assets/svg/navigate_before.svg";
import { ReactComponent as NavigateNext } from "../assets/svg/navigate_next.svg";
import { ReactComponent as Add } from "../assets/svg/add.svg";
import { ReactComponent as ThreeSixty } from "../assets/svg/360.svg";
import { ReactComponent as MenuBook } from "../assets/svg/menu_book.svg";
import { ReactComponent as Reply } from "../assets/svg/reply.svg";
import { ReactComponent as Close } from "../assets/svg/close.svg";
import { ReactComponent as ZoomIn } from "../assets/svg/zoom_in.svg";
import { ReactComponent as ZoomOut } from "../assets/svg/zoom_out.svg";
import { ReactComponent as ExpandMore } from "../assets/svg/expand_more.svg";
import { ReactComponent as ExpandLess } from "../assets/svg/expand_less.svg";
import { ReactComponent as Search } from "../assets/svg/search.svg";
import { ReactComponent as Height } from "../assets/svg/height.svg";
import { ReactComponent as Apps } from "../assets/svg/apps.svg";
import { ReactComponent as Play } from "../assets/svg/play_arrow.svg";
import { ReactComponent as ArrowUp } from "../assets/svg/arrow_upward.svg";
import { ReactComponent as RateReview } from "../assets/svg/rate_review.svg";
import { ReactComponent as SentimentVeryDissatisfied } from "../assets/svg/sentiment_very_dissatisfied.svg";
import { ReactComponent as SentimentDissatisfied } from "../assets/svg/sentiment_dissatisfied.svg";
import { ReactComponent as SentimentNeutral } from "../assets/svg/sentiment_neutral.svg";
import { ReactComponent as SentimentSatisfied } from "../assets/svg/sentiment_satisfied.svg";
import { ReactComponent as SentimentVerySatisfied } from "../assets/svg/sentiment_very_satisfied.svg";

import { IconKey } from "../models/client";

interface IconProps {
  icon: IconKey;
}

export const iconMap = {
  arrowForward: <ArrowForward />,
  arrowUpward: <ArrowUp />,
  navigateBefore: <NavigateBefore />,
  navigateNext: <NavigateNext />,
  add: <Add />,
  threeSixty: <ThreeSixty />,
  menuBook: <MenuBook />,
  reply: <Reply />,
  close: <Close />,
  zoomIn: <ZoomIn />,
  zoomOut: <ZoomOut />,
  expandMore: <ExpandMore />,
  expandLess: <ExpandLess />,
  search: <Search />,
  height: <Height />,
  apps: <Apps />,
  play: <Play />,
  rateReview: <RateReview />,
  sentimentVeryDissatisfied: <SentimentVeryDissatisfied />,
  sentimentDissatisfied: <SentimentDissatisfied />,
  sentimentNeutral: <SentimentNeutral />,
  sentimentSatisfied: <SentimentSatisfied />,
  sentimentVerySatisfied: <SentimentVerySatisfied />,
};

const getIcon = (key: IconKey): JSX.Element => {
  return iconMap[key] || <span></span>;
};

function Icon({ icon }: IconProps) {
  return getIcon(icon);
}

export default Icon;
